// Carry Roll Ball model — ball-type/equipment modifiers (6.7). Pure functions.
export const BALL_MODIFIERS = {
    tour: {
        type: 'tour',
        label: 'Tour / premium urethane',
        dragAdjust: 1.0,
        liftAdjust: 1.0,
        spinRetention: 1.0,
        speedFactor: 1.0,
    },
    urethane: {
        type: 'urethane',
        label: 'Urethane mid-tier',
        dragAdjust: 1.01,
        liftAdjust: 0.98,
        spinRetention: 0.95,
        speedFactor: 0.995,
    },
    ionomer: {
        type: 'ionomer',
        label: 'Ionomer (surlyn)',
        dragAdjust: 1.03,
        liftAdjust: 0.92,
        spinRetention: 0.8,
        speedFactor: 1.01,
    },
    distance: {
        type: 'distance',
        label: 'Distance ball (low spin)',
        dragAdjust: 0.98,
        liftAdjust: 0.85,
        spinRetention: 0.7,
        speedFactor: 1.02,
    },
    soft: {
        type: 'soft',
        label: 'Soft feel (high spin)',
        dragAdjust: 1.04,
        liftAdjust: 1.05,
        spinRetention: 1.1,
        speedFactor: 0.98,
    },
};
/**
 * Apply ball-type modifiers to an effective ball speed (6.7).
 * Returns adjustment factors for use in flight.
 */
export function applyBallModel(ballType) {
    return BALL_MODIFIERS[ballType] ?? BALL_MODIFIERS.tour;
}
//# sourceMappingURL=ballModel.js.map